package medicine.components

import antd.button.button
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.input.textArea
import antd.message.message
import antd.pageheader.pageHeader
import com.jingfangpai.api.clients.MedicineApiClient
import com.jingfangpai.common.orm.mapping.Medicine
import com.jingfangpai.common.orm.mapping.enums.MedicineName
import com.jingfangpai.common.orm.mapping.enums.MedicineType
import kotlinext.js.Object
import kotlinx.browser.window
import react.*
import react.dom.div
import react.dom.jsStyle
import react.router.dom.useHistory
import setTitle

external interface MedicineEditProps : RProps {
    var id: String
}

val MedicineEdit = functionalComponent<MedicineEditProps> { props ->

    val history = useHistory()
    val (medicine, setMedicine) = useState(Medicine())
    val (loading, setLoading) = useState(false)
    val (saving, setSaving) = useState(false)

    useEffect(props.id) {
        if (props.id != "new" && props.id.isNotBlank()) {
            setLoading(true)
            MedicineApiClient.getDetail(props.id, { resp ->
                setLoading(false)
                if (resp.ok() && resp.data != null) {
                    setMedicine(resp.data!!)
                    setTitle("编辑中药 - ${resp.data!!.name?.getLiteral() ?: ""}")
                } else {
                    message.error("获取中药失败")
                }
            }, {
                setLoading(false)
                message.error("获取中药失败")
            })
        } else {
            setTitle("新增中药")
        }
    }

    fun updateMedicine(updater: (Medicine) -> Unit) {
        val newMedicine = Object.assign(Medicine(), medicine)
        updater(newMedicine)
        setMedicine(newMedicine)
    }

    fun save() {
        setSaving(true)
        MedicineApiClient.save(medicine, { resp ->
            setSaving(false)
            if (resp.ok()) {
                message.success("保存成功")
                history.push(SmartTcmRoute.MedicineDetail.link.url.replace(":id", resp.data?.id ?: ""))
            } else {
                message.error("保存失败：${resp.message}")
            }
        }, {
            setSaving(false)
            message.error("保存失败")
        })
    }

    div("MedicineEdit") {
        attrs.jsStyle = kotlinext.js.js {
            margin = "0 auto"
            maxWidth = "800px"
        }

        pageHeader {
            attrs {
                className = "medicine-edit-page-header-responsive"
                onBack = {
                    window.history.back()
                }
                title = if (props.id == "new") "新增中药" else "编辑中药"
                subTitle = ""
            }
        }

        if (loading) {
            div {
                +"加载中..."
            }
        } else {
            form {
                attrs {
                    layout = "vertical"
                }

                formItem {
                    attrs {
                        label = "名称"
                    }
                    input {
                        attrs {
                            value = medicine.name?.getLiteral() ?: ""
                            placeholder = "请输入中药名称"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updateMedicine { it.name = MedicineName.valueOf(event.target.value as String) } // This might not work, need proper enum handling
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "别名"
                    }
                    input {
                        attrs {
                            value = medicine.aliasName ?: ""
                            placeholder = "请输入别名"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updateMedicine { it.aliasName = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "类型"
                    }
                    input {
                        attrs {
                            value = medicine.type?.getLiteral() ?: ""
                            placeholder = "请输入类型"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updateMedicine { it.type = MedicineType.valueOf(event.target.value as String) } // This might not work
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "描述"
                    }
                    textArea {
                        attrs {
                            value = medicine.description ?: ""
                            rows = 4
                            placeholder = "请输入描述"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updateMedicine { it.description = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "比较鉴别"
                    }
                    textArea {
                        attrs {
                            value = medicine.differentiation ?: ""
                            rows = 4
                            placeholder = "请输入比较鉴别信息"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updateMedicine { it.differentiation = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    button {
                        attrs {
                            type = "primary"
                            onClick = {
                                save()
                            }
                        }
                        attrs.loading = saving
                        +"保存"
                    }
                }
            }
        }
    }
}
